import { z } from "zod";
export const ninjaTicketCategorySchema = z.enum([
    "INCIDENT",
    "PROBLEM",
    "QUESTION",
    "TASK",
    "CHANGE_REQUEST",
    "SERVICE_REQUEST",
    "MISCELLANEOUS"
]);
export const ninjaTicketPrioritySchema = z.enum([
    "NONE",
    "LOW",
    "MEDIUM",
    "HIGH"
]);
export const createNinjaServiceTicketSchema = z.object({
    title: z.string().trim().min(3).max(200),
    description: z.string().trim().max(10_000).default(""),
    category: ninjaTicketCategorySchema.default("INCIDENT"),
    priority: ninjaTicketPrioritySchema.default("MEDIUM")
});
